export default "__VITE_ASSET__DdpEYYQA__"